export default __webpack_public_path__ + "632d06c74344d6fc4002490bc429afec.png";